import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=ca7e1ff4&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=js&"
export * from "./auth.vue?vue&type=script&lang=js&"
import style0 from "./auth.vue?vue&type=style&index=0&id=ca7e1ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7e1ff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7e1ff4')) {
      api.createRecord('ca7e1ff4', component.options)
    } else {
      api.reload('ca7e1ff4', component.options)
    }
    module.hot.accept("./auth.vue?vue&type=template&id=ca7e1ff4&scoped=true&", function () {
      api.rerender('ca7e1ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/auth/auth.vue"
export default component.exports